/**
 * rest/finops.ts — Client REST FinOps / Premium Assistia (S5.4-08)
 */
// ── Données demo ──────────────────────────────────────────────────────────────
const DEMO_DASHBOARD = {
    total_calls_today: 142,
    total_tokens_today: 284_000,
    total_cost_eur: 3.41,
    models_breakdown: {
        'mistral-large': { calls: 89, tokens: 178_000, cost_eur: 2.14 },
        'mistral-small': { calls: 53, tokens: 106_000, cost_eur: 1.27 },
    },
    period_start: new Date(Date.now() - 86_400_000).toISOString(),
    period_end: new Date().toISOString(),
};
// ── Implémentation ────────────────────────────────────────────────────────────
export class FinopsClientImpl {
    http;
    sim;
    constructor(http, sim) {
        this.http = http;
        this.sim = sim;
    }
    getDashboard() {
        return this.http.get('/api/v1/admin/finops/dashboard', async () => DEMO_DASHBOARD);
    }
    getFinopsKpi() {
        return this.http.get('/api/v1/finops/data', async () => ({
            avg_cost_eur: 0.18,
            avg_duration_ms: 95_000,
            success_rate_pct: 97.2,
            avg_confidence_pct: 91.4,
            total_dossiers: 142,
            daily_costs: [
                { date: '2026-05-29', cost_eur: 0.16, count: 41 },
                { date: '2026-05-30', cost_eur: 0.19, count: 58 },
                { date: '2026-05-31', cost_eur: 0.18, count: 43 },
            ],
            recent_dossiers: [],
        }));
    }
    getUsageHistory(days = 30) {
        return this.http.get(`/api/v1/admin/finops/history?days=${days}`, async () => (this.sim?.getAdminData('finops_history') ?? []));
    }
    listPremiumUsers() {
        return this.http.get('/api/v1/admin/premium/users', async () => (this.sim?.getAdminData('premium_users') ?? []));
    }
}
//# sourceMappingURL=finops.js.map